import { Component, OnInit, OnDestroy, OnChanges, Input, HostListener, ElementRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SMSBasic } from 'src/app/models/turns-models/turns-sms-basic.model';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Subscription } from 'rxjs';
import { SmsService } from 'src/app/services/sms-service/smsservice';

@Component({
  selector: 'app-sms-sms-info-card',
  templateUrl: './sms-sms-info-card.component.html',
  styleUrls: ['./sms-sms-info-card.component.scss']
})
export class SmsSmsInfoCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() sms: SMSBasic;
  editingLocked: boolean;
  updateSmsSubscription: Subscription;
  basicDataForm = new FormGroup({
    active: new FormControl({ value: true, disabled: true }),
    smsName: new FormControl({ value: null, disabled: true }, Validators.required),
    smsSubject: new FormControl({ value: null, disabled: true }, Validators.required)
  });

  constructor(private smsService: SmsService,
    private eRef: ElementRef,
    private userStorageService: UserStorageService,
    private snackbarService: SnackBarService) {
      this.editingLocked = true;
  }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.sms) {
      this.resetForm();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
    } else {
      if (event.path[0].className !== 'mat-option-text') {
        if (this.sms && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
        }
      }
    }
  }

  public submitForm() {
    this.updateSmsSubscription = this.smsService.updateSmsInfo(this.sms.InternalId, this.basicDataForm.get('smsName').value, this.basicDataForm.get('active').value, this.basicDataForm.get('smsSubject').value).subscribe(
      (res) => {
        this.snackbarService.open('sms-page.snackbar messages.update sms success', 'success');
        this.lockEdition();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
      } else {
        this.snackbarService.open(validation, 'error');
      }
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('smsName').valid) {
      return 'sms-page.snackbar messages.name sms error';
    } else if (!this.basicDataForm.get('smsSubject').valid) {
      return 'sms-page.snackbar messages.subject sms error';
    } else {
      return true;
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      active: this.sms.Active,
      smsName: this.sms.SmsName,
      smsSubject: this.sms.SmsSubject
    });
  }

  public unlockEdition() {
    this.basicDataForm.get('active').enable();
    this.basicDataForm.get('smsName').enable();
    this.basicDataForm.get('smsSubject').enable();
    this.editingLocked = false;
  }

  public lockEdition() {
    this.basicDataForm.get('active').disable();
    this.basicDataForm.get('smsName').disable();
    this.basicDataForm.get('smsSubject').disable();
    this.editingLocked = true;
  }

  ngOnDestroy() {
    if (this.updateSmsSubscription) { this.updateSmsSubscription.unsubscribe(); }
  }
}
